module.exports = __webpack_public_path__ + "img/购物车.8e493c30.svg";